import { render } from "./RatingStar.vue?vue&type=template&id=6ca497a2&scoped=true"
import script from "./RatingStar.vue?vue&type=script&lang=js"
export * from "./RatingStar.vue?vue&type=script&lang=js"

import "./RatingStar.vue?vue&type=style&index=0&id=6ca497a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ca497a2"]])

export default __exports__